import { adminFetch } from './dataProvider';

interface AssignmentResponse {
  assignedTo: string | null;
}

/**
 * PATCH /v1/admin/leads/:id/assignment — sets or clears the free-text
 * "Assigned to" field on a lead. Pass null (or an empty string, which
 * the server normalises to null) to clear.
 *
 * Returns the server-confirmed value (trimmed; empty-after-trim
 * coerced to null), so the caller can replace its optimistic state
 * with the canonical version on success.
 */
export async function setAssignment(
  personId: string,
  assignedTo: string | null,
): Promise<string | null> {
  const body = await adminFetch<AssignmentResponse>(
    `/v1/admin/leads/${personId}/assignment`,
    {
      method: 'PATCH',
      body: JSON.stringify({ assignedTo }),
    },
  );
  return body.assignedTo ?? null;
}
